module.exports = __webpack_public_path__ + "img/undo-icon-white.416381d9.svg";